import { getI18nKebbabFormat } from 'utils/i18n';

const { REACT_APP_GOOGLE_MAPS_API_URL } = process.env;

export default (apiKey, language) =>
  new Promise((resolve, reject) => {
    const GMapsLibraryScript = document.createElement('script');
    GMapsLibraryScript.src = `${REACT_APP_GOOGLE_MAPS_API_URL}?key=${apiKey}&libraries=maps,places&language=${getI18nKebbabFormat(language)}`;
    GMapsLibraryScript.async = false;

    GMapsLibraryScript.onload = resolve;
    GMapsLibraryScript.onerror = reject;

    document.getElementsByTagName('head')[0].appendChild(GMapsLibraryScript);
  });
